<template v-slot:item="data">
    <q-card
        @click="$emit('select')"
        class="q-pa-sm q-ma-sm"
        :class="{
            'group-card--selectable': isSelectable,
            'group-card--selected': isSelected
        }"
        bordered
        flat
    >
        <q-card-section horizontal>
            <div class="full-width justify-around">
                <!-- Fields -->
                <div>
                    <div class="text-h6 q-mb-sm">
                        {{ name }}
                    </div>
                    <q-expansion-item
                        switch-toggle-side
                        :label="$t('Show Assets')"
                    >
                        <q-list
                            class="q-mb-md text-grey-8 group-card--field"
                            v-if="assets[0] !== null"
                        >
                            <q-item v-for="asset in assets" :key="asset" dense>
                                {{ assetsMap[asset] }}
                            </q-item>
                        </q-list>
                    </q-expansion-item>
                </div>
            </div>

            <!-- Actions -->
            <q-separator vertical></q-separator>
            <q-card-actions
                class="col-auto justify-around q-pl-xs q-pr-none"
                align="right"
                vertical
            >
                <q-card-actions
                    v-if="isSelectable"
                    class="col-auto justify-around q-pl-xs q-pr-none"
                    align="right"
                    vertical
                >
                    <q-icon
                        :name="
                            isSelected ? 'fas fa-check-square' : 'fal fa-square'
                        "
                        color="primary"
                        size="md"
                    ></q-icon>
                </q-card-actions>
                <q-card-actions
                    v-else
                    class="col-auto justify-around q-pl-xs q-py-none q-pr-none"
                    align="right"
                    vertical
                >
                    <q-separator vertical></q-separator>
                    <q-btn
                        @click="$emit('edit')"
                        :disable="!canEdit"
                        :color="!canEdit ? 'grey' : 'accent'"
                        class="q-pa-sm card__button--edit"
                        icon="fas fa-edit"
                        size="md"
                        flat
                    />
                    <q-btn
                        @click="$emit('delete')"
                        :disable="!canDelete"
                        :color="!canDelete ? 'grey' : 'red-6'"
                        class="q-pa-sm card__button--delete"
                        icon="fas fa-trash"
                        size="md"
                        flat
                    />
                </q-card-actions>
            </q-card-actions>
        </q-card-section>
    </q-card>
</template>

<script>
import { useAssetsStore } from '@stores/assets';
import { mapState } from 'pinia';

export default {
    name: 'GroupCard',
    emits: ['select', 'edit', 'delete'],
    props: {
        /**
         * group fields.
         */
        name: {
            type: String,
            required: true
        },
        facilityId: {
            type: [Number, String],
            required: true
        },
        assets: {
            type: [Array],
            required: true
        },
        /**
         * Card options.
         */
        // is the card currently selected?
        isSelected: {
            type: Boolean,
            required: false,
            default: false
        },
        // should cards be selectable?
        isSelectable: {
            type: Boolean,
            required: false,
            default: false
        },
        // permissions
        canEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        canDelete: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapState(useAssetsStore, ['getAssets']),
        /**
         * Get Assets for facility.
         * @return {Object} - Assets.
         */
        assetsMap() {
            const assets = this.getAssets(this.facilityId).reduce(function (
                map,
                obj
            ) {
                map[obj.id] = obj.name;
                return map;
            }, {});
            return assets;
        }
    }
};
</script>

<style lang="scss">
.group-card--field {
    font-size: 17px;
}

.group-card--input__lte_xs {
    padding-right: 10px;
    width: 100%;
}

.group-card--input__gt_xs {
    width: 250px;
}

.group-card__description {
    color: $grey-7;
}

.group-card--selectable {
    cursor: pointer;
}

.group-card--selected {
    background-color: $grey-3;
}

.target-downtime {
    display: inline-block;
}
</style>
